import { render } from "./GroupList.vue?vue&type=template&id=1341ff9a"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"
script.render = render

export default script